/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { userID } from './userID';
export type User = {
    id: userID;
    name?: string;
    money?: number;
    work?: number;
    pay?: string;
    pay_type?: User.pay_type;
    email?: string;
    phone?: string;
    email_notify?: boolean;
    economics?: boolean;
    juridas?: boolean;
    humanitary?: boolean;
    technology?: boolean;
    languages?: boolean;
};
export namespace User {
    export enum pay_type {
        WEBMONEY = 'Webmoney',
        YANDEX = 'Yandex',
        CARD = 'Card',
        QIWI = 'Qiwi',
        CASH_ON_HANDS_SVETA = 'CashOnHandsSveta',
        CASH_ON_HANDS_ANDREY = 'CashOnHandsAndrey',
    }
}

